import React from 'react';
import { graphql, useFragment } from 'react-relay';
import type { projectNotificationsAccordion_personalSettingsNotificationsConfigTable$key } from '@atlassian/jira-relay/src/__generated__/projectNotificationsAccordion_personalSettingsNotificationsConfigTable.graphql';
import { Accordion } from '../../../../common/ui/accordion/index.tsx';

export const ProjectNotificationsAccordion = ({
	children,
	project,
}: React.PropsWithChildren<{
	project: projectNotificationsAccordion_personalSettingsNotificationsConfigTable$key;
}>) => {
	const projectData = useFragment(
		graphql`
			fragment projectNotificationsAccordion_personalSettingsNotificationsConfigTable on JiraProject {
				id @required(action: THROW)
				avatar @required(action: THROW) {
					xsmall @required(action: THROW)
				}
				name @required(action: THROW)
			}
		`,
		project,
	);
	return (
		<Accordion
			id={projectData.id}
			projectName={projectData.name}
			projectAvatar={projectData.avatar.xsmall}
		>
			{children}
		</Accordion>
	);
};
